import styled from "styled-components";

// tslint:disable-next-line
export const ManagerSearchFilterOuterContainer = styled.div`
  display: inline-block;
  vertical-align: top;
  position: relative;
  margin-left: 2px;
`;
